class DateUtils {
  formatAllDates = data => {
    if (data instanceof Date) {
      return this.formatDateToISOString(data);
    }

    if (Array.isArray(data)) {
      return data.map(val => this.formatAllDates(val));
    }

    if (typeof data === "object" && data !== null) {
      return Object.fromEntries(Object.entries(data).map(([key, val]) =>
        [key, this.formatAllDates(val)]));
    }

    return data;
  };

  formatDateToISOString = utcDate => {
    if (!utcDate) {
      return utcDate;
    }

    const convertedUtcDate = utcDate instanceof Date
      ? utcDate
      : new Date(utcDate);

    const yearIdx = 2;
    const monthIdx = 0;
    const dayIdx = 1;

    const localeDateString = convertedUtcDate.toLocaleDateString("en-US");
    const dateParts = localeDateString.split("/");
    return `${dateParts[yearIdx]}-${this.formatDatePart(dateParts[monthIdx])}-${this.formatDatePart(dateParts[dayIdx])}`;
  };

  formatDatePart = part => part.padStart(2, 0);
}

const dateUtils = new DateUtils();
export default dateUtils;